/**
 * Reorders a list of items after a drag and drop. Typically invoked as a
 * response to the 'move' event from DraggableList
 *
 * @param {Array} collection the collection to mutate to reflect the new order
 * @param {Number} newIndex the new index of the moved item
 * @param {Number} prevIndex the previous index of the moved item
 */
function reorderAfterDrag(collection, newIndex, prevIndex) {
	let item = collection[prevIndex]
	collection.splice(prevIndex, 1)
	collection.splice(newIndex, 0, item)
}

export default reorderAfterDrag

reorderAfterDrag.__filename__ = 'components/reorder-after-drag.js'
